/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Body2, Body1 } from "@iventis/styles/src/components/texts";
import { FieldConfig, useField } from "formik";
import { styled } from "@iventis/styles";
import { format } from "date-fns";
import { AutocompleteWithLoading } from "@iventis/components";
import { utcToZonedTime } from "date-fns-tz";

/**
 * This component wraps an Autocomplete input into a Formik Field so that it can be "plugged in" to the session Form
 * To be able to display customised option labels and input, it uses internally a Map consisted of:
 *  --> key: the number of the Day of the given schedule (uses day 0 as a pivot)
 *  --> value: the Date object
 */
interface SessionDayWrapperProps extends FieldConfig {
    timezone: string;
    scheduleDaysMap?: Map<number, Date>;
    label?: string;
}
const SessionDayWrapperFormik: React.FunctionComponent<SessionDayWrapperProps> = ({ timezone, scheduleDaysMap, label, ...props }) => {
    const { name } = props;
    const [field, meta, helpers] = useField(name);

    return (
        <>
            <AutocompleteWithLoading
                value={field.value}
                label={label}
                options={Array.from(scheduleDaysMap.keys())}
                renderOption={(props, option) => (
                    <StyledRenderOption {...props} key={option}>
                        <Body2>{format(utcToZonedTime(scheduleDaysMap.get(option), timezone), "EEE, d MMM yyyy")}</Body2>
                        <Body1>{`Day ${option}`}</Body1>
                    </StyledRenderOption>
                )}
                getOptionLabel={(option: number) => {
                    if (scheduleDaysMap.get(option)) {
                        return `Day ${option} (${format(utcToZonedTime(scheduleDaysMap.get(option), timezone), "EEE, d MMM yyyy")})`;
                    }
                    return "Select day";
                }}
                getOptionSelected={(option: number, value: number) => {
                    if (value === null || option === null) return false;
                    if (option === value) return true;
                    return false;
                }}
                loadingOptions={false}
                onChange={(value: number) => {
                    helpers.setValue(value, true);
                }}
                error={!!(meta.touched && meta.error)}
                helperText={meta.touched && meta.error}
            />
        </>
    );
};

const StyledRenderOption = styled.div`
    display: flex;
    width: 100%;

    &.MuiAutocomplete-option {
        justify-content: space-between;
    }
`;
export default SessionDayWrapperFormik;
